import React, { Component } from "react";
import PropTypes from "prop-types";
import Postmate from "@myplay/postmate";

const LOCAL_URL = "http://localhost:8080";
const PROD_URL = "https://myplay-assets.gcdn.co/mvp/production/index.html";

class BaseVideoPlayerWithConnector extends Component {
  state = {
    connector: null
  };

  async componentDidMount() {
    const { onConnector } = this.props;

    const handshake = new Postmate({
      container: document.getElementById(this.props.iframeId),
      url: this.src
    });

    handshake
      .then(child => {
        if (child && child.frame) {
          child.frame.setAttribute("allowFullscreen", "");
        }
        this.setState({ connector: child });
        if (onConnector) {
          onConnector(child);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    const {
      iframeUrl,
      type,
      srcId,
      isHighlight,
      height,
      width,
      accountType,
      disableFullscreen,
      children,
      render,
      isNakedVideoPlayer,
      teamId
    } = this.props;
    this.src =
      isHighlight === undefined
        ? `${iframeUrl}?${type}=${srcId}&accountType=${accountType}&disableFullscreen=${disableFullscreen}&nakedPlayer=${isNakedVideoPlayer}&currentTeam=${teamId}`
        : `${iframeUrl}?${type}=${srcId}&highlight=true`;

    return (
      <div style={{ width: "100%", height: "100%" }}>
        {children}
        {render(this.state)}
      </div>
    );
  }
}

BaseVideoPlayerWithConnector.propTypes = {
  /** id for element to inject frame into */
  iframeId: PropTypes.string.isRequired,
  iframeUrl: PropTypes.string.isRequired,
  /** Type of video player currently video or live */
  type: PropTypes.string.isRequired,
  srcId: PropTypes.string.isRequired,
  isHighlight: PropTypes.bool,
  /** Set the video height  */
  height: PropTypes.string.isRequired,
  /** Set the video width  */
  width: PropTypes.string.isRequired,
  /** accountType : operator/coach/player/tagger */
  accountType: PropTypes.string.isRequired
};
BaseVideoPlayerWithConnector.defaultProps = {
  iframeUrl: PROD_URL,
  height: "100%",
  width: "100%",
  accountType: "player"
};

export default BaseVideoPlayerWithConnector;

// https://stream.myplay.com/mvp-dev
